// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"a08f1f8d","139":"bbf3e295","328":"bbf3e295","609":"a08f1f8d"}[chunkId] + ".chunk.css";
};